import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  MenuItem,
  MenuList,
  Paper,
  Popover,
} from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import OverlayRightPanel from "containers/OverlayRightPanel/OverlayRightPanel.container";
import UploadRuleEngineJsonForm from "../../ProductsList/UploadRuleEngineJsonForm";

const UploadRulesEngineJsonButton = ({
  executeOnMenuItemSelect = false,
}: {
  executeOnMenuItemSelect?: boolean;
}) => {
  //State
  const anchorRef = useRef<HTMLDivElement>(null);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [selectedAction, setSelectedAction] = useState<number>(() => {
    // Check localStorage for the saved value, default to 0 if not found
    const saved = localStorage.getItem(
      "productline.uploadRulesEngineJsonIndex"
    );
    return saved === null ? 0 : parseInt(saved, 10);
  });
  const [showInputsForm, setShowInputsForm] = useState<boolean>(false);

  //Define actions for the button
  const actions: string[] = [
    "Upload Rules Engine Json File to Sandbox",
    "Upload Rules Engine Json File to Dev",
  ];

  //useEffects

  useEffect(() => {
    //persist change of button action to localstorage
    localStorage.setItem(
      "productline.uploadRulesEngineJsonIndex",
      selectedAction.toString()
    );
  }, [selectedAction]);

  //Private Methods

  const initiateAction = () => {
    setShowInputsForm(true);
  };

  //Event Handlers

  const handleClick = () => {
    initiateAction();
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setSelectedAction(index);
    setMenuOpen(false);

    //Execute the click action if props tell us to do that
    if (executeOnMenuItemSelect) initiateAction();
  };

  const handleMenuToggle = () => {
    setMenuOpen((prevOpen) => !prevOpen);
  };

  const handleImportRuleEngineJsonPress = () => {
    setShowInputsForm(!showInputsForm);
  };

  return (
    <React.Fragment>
      {showInputsForm && (
        <OverlayRightPanel
          open={showInputsForm}
          closeNav={handleImportRuleEngineJsonPress}
          title={actions[selectedAction] ?? "Upload Rules Engine Json"}
        >
          <UploadRuleEngineJsonForm
            selectedAction={selectedAction}
            visible={showInputsForm}
          />
        </OverlayRightPanel>
      )}
      <ButtonGroup
        variant="outlined"
        size="small"
        color="primary"
        ref={anchorRef}
        aria-label="Button group with a nested menu"
      >
        <Button startIcon={<FileUploadIcon />} onClick={handleClick}>
          {actions[selectedAction]}
        </Button>
        <Button size="small" onClick={handleMenuToggle}>
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popover
        id="split-button-menu-popover"
        open={menuOpen}
        onClose={handleMenuClose}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Paper>
          <MenuList id="split-button-menu" variant="selectedMenu" autoFocusItem>
            {actions.map((option, index) => (
              <MenuItem
                key={option}
                selected={index === selectedAction}
                onClick={(event) => handleMenuItemClick(event, index)}
              >
                {option}
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      </Popover>
    </React.Fragment>
  );
};

export default UploadRulesEngineJsonButton;
